import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useIsMobile from './useIsMobile';
import './App.css';

function Termeni() {
    useEffect(() => { window.scrollTo(0, 0); document.title = 'Termeni și Condiții | SPCheapCars'; }, []);

    const primaryOrange = "#ff8e18";
    const trustNavy = "#1c2e4a";
    const isMobile = useIsMobile();

    const heroTexture = [
        'repeating-linear-gradient(125deg, transparent 0px, transparent 16px, rgba(255,255,255,0.06) 16px, rgba(255,255,255,0.06) 17px)',
        'repeating-linear-gradient(35deg, transparent 0px, transparent 32px, rgba(255,142,24,0.045) 32px, rgba(255,142,24,0.045) 33px)',
        'radial-gradient(ellipse at 70% 0%, rgba(255,142,24,0.1) 0%, transparent 50%)',
        'linear-gradient(180deg, rgba(28,46,74,0) 0%, rgba(15,26,43,0.5) 100%)'
    ].join(', ');

    const sections = [
        {
            icon: 'bi-info-circle-fill', title: '1. Informații Generale',
            body: <>Site-ul SPCheapCars este operat de SC SPCheapCars SRL, cu sediul în Timișoara, Str. Grigore Alexandrescu 121. Prin accesarea site-ului, acceptați acești termeni.</>
        },
        {
            icon: 'bi-cash-stack', title: '2. Prețurile',
            body: <>Prețurile afișate pe site sunt în <strong>EUR</strong> și includ TVA. Cursul valutar RON afișat este informativ și se actualizează automat. Prețul final se stabilește la momentul tranzacției.</>
        },
        {
            icon: 'bi-car-front-fill', title: '3. Informații despre Vehicule',
            body: <>Depunem toate eforturile pentru a asigura acuratețea informațiilor prezentate. Fotografiile și specificațiile sunt orientative. Vă recomandăm să verificați personal vehiculul înainte de achiziție.</>
        },
        {
            icon: 'bi-shield-check', title: '4. Garanție',
            body: <>Toate vehiculele comercializate beneficiază de garanție conform legislației în vigoare. Detalii suplimentare pe pagina <Link to="/garantie" style={{ color: primaryOrange, fontWeight: 600 }}>Garanție</Link>.</>
        },
        {
            icon: 'bi-truck', title: '5. Livrare',
            body: <>Oferim servicii de livrare la nivel național. Costurile și termenele de livrare sunt detaliate pe pagina <Link to="/livrare" style={{ color: primaryOrange, fontWeight: 600 }}>Livrare</Link>.</>
        },
        {
            icon: 'bi-c-circle', title: '6. Proprietate Intelectuală',
            body: <>Conținutul site-ului (texte, imagini, logo-uri) este proprietatea SPCheapCars și nu poate fi reprodus fără acord scris.</>
        },
        {
            icon: 'bi-telephone-fill', title: '7. Contact',
            body: <>Pentru orice întrebări legate de acești termeni, ne puteți contacta la telefon <strong>0741 811 511</strong> sau email <strong>contact@spcheapcars.ro</strong>.</>
        }
    ];

    return (
        <div style={{ background: '#f0f4f9', minHeight: '100vh' }}>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 1 — HERO (dark navy)
            ══════════════════════════════════════════════════════════════ */}
            <div className="position-relative page-hero" style={{ background: trustNavy, paddingTop: isMobile ? '32px' : '120px', paddingBottom: isMobile ? '40px' : '64px' }}>
                <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: heroTexture }}></div>
                <div className="container text-center text-white position-relative">
                    <div style={{
                        display: 'inline-block', background: `${primaryOrange}22`,
                        border: `1px solid ${primaryOrange}55`, color: primaryOrange,
                        fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase',
                        letterSpacing: '3px', padding: '5px 16px', borderRadius: '40px', marginBottom: '18px'
                    }}>LEGAL</div>
                    <h1 style={{
                        fontWeight: '800', letterSpacing: isMobile ? '1px' : '3px',
                        fontSize: isMobile ? '2rem' : 'clamp(2.2rem, 5vw, 3.5rem)',
                        textTransform: 'uppercase', color: '#ffffff', lineHeight: '1.15', marginBottom: '12px'
                    }}>Termeni și Condiții</h1>
                    <div style={{ width: '50px', height: '3px', background: primaryOrange, margin: '0 auto 16px', borderRadius: '2px' }}></div>
                    <p style={{ opacity: 0.7, maxWidth: '460px', margin: '0 auto', fontSize: '1rem', lineHeight: '1.7' }}>
                        Vă rugăm să citiți cu atenție termenii și condițiile de utilizare înainte de a folosi site-ul nostru.
                    </p>
                    <p style={{ opacity: 0.7, fontSize: '0.875rem', margin: '12px 0 0' }}>Ultima actualizare: iulie 2026</p>
                </div>
            </div>

            {/* ══════════════════════════════════════════════════════════════
                SECTION 2 — CONȚINUT (light)
            ══════════════════════════════════════════════════════════════ */}
            <div className="ip-section">
                <div className="container">
                    <div className="row g-3">
                        {sections.map((s, i) => (
                            <div className="col-12 col-md-6" key={i}>
                                <div className="ip-card">
                                    <div className="ip-tile ip-tile--sm">
                                        <i className={`bi ${s.icon}`}></i>
                                    </div>
                                    <div>
                                        <h6 className="ip-card-title">{s.title}</h6>
                                        <p className="ip-card-text">{s.body}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Termeni;
